import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipcardInfoComponent } from './tipcard-info.component';


@NgModule({
  declarations: [
    TipcardInfoComponent
  ],
  exports: [
    TipcardInfoComponent
  ],
  imports: [
    CommonModule,
  ]
})
export class TipcardInfoModule { }
